import React from "react";

function Lawsuitcarousal() {
  return <div className="Lawsuitcarousal">Lawsuitcarousal</div>;
}

export default Lawsuitcarousal;
